/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const Complexe = require('../types/Complexe')
const Ope = require('../types/Ope')
const CCb = require('./CCb')
const CCbGlob = require('../kernel/CCbGlob')
module.exports = CMoinsUnaire

/**
 * @constructor
 * @extends CCb
 * Classe représentant le moins unaire dans un arbre binaire de calcul
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CCb} operande : L'opérande (lui-même un CCb)
 * @returns {CMoinsUnaire}
 */
function CMoinsUnaire (listeProprietaire, operande) {
  CCb.call(this, listeProprietaire);
  if (arguments.length !== 1) {
    this.operande = operande;
  }
  this._c1 = new Complexe();
}
CMoinsUnaire.prototype = new CCb();
CMoinsUnaire.prototype.constructor = CMoinsUnaire;
CMoinsUnaire.prototype.superClass = "CCb";
CMoinsUnaire.prototype.className = "CMoinsUnaire";


CMoinsUnaire.prototype.nature = function() {
  return CCbGlob.natMoinsUnaire;
};

CMoinsUnaire.prototype.getClone = function(listeSource, listeCible) {
  var cloneOperande = this.operande.getClone(listeSource, listeCible);
  return new CMoinsUnaire(listeCible, cloneOperande);
};

CMoinsUnaire.prototype.initialisePourDependance = function() {
  CCb.prototype.initialisePourDependance.call(this);
  this.operande.initialisePourDependance();
};

CMoinsUnaire.prototype.dependDe = function(p) {
    if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
  return this.memoriseDependance(CCb.prototype.dependDe.call(this,p) ||
    this.operande.dependDe(p));
};

CMoinsUnaire.prototype.dependDePourBoucle = function(p) {
  return this.operande.dependDePourBoucle(p);
};

CMoinsUnaire.prototype.existe = function(infoRandom) {
  return this.operande.existe(infoRandom);
};

CMoinsUnaire.prototype.resultat = function(infoRandom) {
   return - this.operande.resultat(infoRandom);
};

CMoinsUnaire.prototype.resultatFonction = function(infoRandom, valeurParametre){
   return - this.operande.resultatFonction(infoRandom, valeurParametre);
};

CMoinsUnaire.prototype.resultatFonction = function(infoRandom, valeurParametre) {
   return - this.operande.resultatFonction(infoRandom, valeurParametre);
};

CMoinsUnaire.prototype.resultatComplexe = function(infoRandom, zRes){
  this.operande.resultatComplexe(infoRandom, this._c1);
  zRes.x = -this._c1.x;
  zRes.y = -this._c1.y;
};

CMoinsUnaire.prototype.resultatFonctionComplexe = function(infoRandom, valeurParametre, zRes){
  this.operande.resultatFonctionComplexe(infoRandom, valeurParametre, this._c1);
  zRes.x = -this._c1.x;
  zRes.y = -this._c1.y;
};

CMoinsUnaire.prototype.resultatFonctionComplexe = function(infoRandom, valeurParametre, zRes){
  this.operande.resultatFonctionComplexe(infoRandom, valeurParametre, this._c1);
  zRes.x = -this._c1.x;
  zRes.y = -this._c1.y;
};

CMoinsUnaire.prototype.dependDeVariable = function(ind) {
  return this.operande.dependDeVariable(ind);
};

CMoinsUnaire.prototype.getCopie = function() {
  return new CMoinsUnaire(this.listeProprietaire, this.operande.getCopie());
};

CMoinsUnaire.prototype.chaineCalcul = function(varFor) {
  var ch;
  if (this.operande.nature() === CCbGlob.natOperation) {
    var op1 = this.operande.Ope;
    if ((op1 === Ope.Plus) || (op1 === Ope.Moin) || Ope.estTest(op1))
      ch = this.operande.chaineCalcul(varFor);
    else ch = this.operande.chaineCalculSansPar(varFor);
  }
  else ch = this.operande.chaineCalcul(varFor);
  return "(-" + ch + ")";
};

CMoinsUnaire.prototype.chaineCalculSansPar = function(varFor) {
  var ch;
  if (this.operande.nature() === CCbGlob.natOperation) {
    var op1 = this.operande.Ope;
    if ((op1 === Ope.Plus) || (op1 === Ope.Moin) || Ope.estTest(op1))
      ch = this.operande.chaineCalcul(varFor);
    else ch = this.operande.chaineCalculSansPar(varFor);
  }
  else ch = this.operande.chaineCalculSansPar(varFor);
  return "-" + ch;
};

CMoinsUnaire.prototype.chaineLatex = function(varFor) {
  var ch;
  if (this.operande.nature() === CCbGlob.natOperation) {
    var op1 = this.operande.Ope;
    if ((op1 === Ope.Mult) || (op1 === Ope.Divi) || Ope.estTest(op1))
      ch = this.operande.chaineLatexSansPar(varFor);
    else ch = this.operande.chaineLatex(varFor);
  }
  else ch = this.operande.chaineLatex(varFor);
  return "\\left(" + "-" + ch + "\\right)";
};

CMoinsUnaire.prototype.chaineLatexSansPar = function(varFor) {
  var ch;
  if (this.operande.nature() === CCbGlob.natOperation) {
    var op1 = this.operande.Ope;
    if ((op1 === Ope.Mult) || (op1 === Ope.Divi) || Ope.estTest(op1))
      ch = this.operande.chaineLatexSansPar(varFor);
    else ch = this.operande.chaineLatex(varFor);
  }
  else ch = this.operande.chaineLatexSansPar(varFor);
  return "-" + ch;
};

CMoinsUnaire.prototype.read = function(inps, list){
  CCb.prototype.read.call(this, inps, list);
  this.operande = inps.readObject(list);
};

CMoinsUnaire.prototype.write = function(oups, list) {
  CCb.prototype.write.call(this, oups, list);
  oups.writeObject(this.operande);
};

CMoinsUnaire.prototype.estConstant = function() {
  return this.operande.estConstant();
};
CMoinsUnaire.prototype.deriveePossible = function(indiceVariable) {
  return this.operande.deriveePossible(indiceVariable);
};
CMoinsUnaire.prototype.calculAvecValeursRemplacees = function() {
  return new CMoinsUnaire(this.listeProprietaire, this.operande.calculAvecValeursRemplacees()) ;
};

CMoinsUnaire.prototype.membreGauche = function() {
  if (this.operande.nature() === CCbGlob.natOperation) {
    if ((this.operande.Ope === Ope.Mult) || (this.operande.Ope === Ope.Divi))
      return new CMoinsUnaire(this.listeProprietaire,this.operande.operande1);
  }
  return CCb.prototype.membreGauche.call(this);
};

CMoinsUnaire.prototype.membreDroit = function() {
  if (this.operande.nature() === CCbGlob.natOperation) {
    if ((this.operande.Ope === Ope.Mult) || (this.operande.Ope === Ope.Divi))
      return this.operande.operande2;
  }
  return CCb.prototype.membreDroit.call(this);
};




// WEBPACK FOOTER //
// ./src/objets/CMoinsUnaire.js